import { createContext, useContext, useEffect} from "react";
import { UserContext } from '../user';
import { toast } from '../../components/common';
import useHub from "../../services/Hub";

const UpdateHubContext = createContext();

const UpdateHubProvider = ({children}) => { 
    const { userDetails } = useContext(UserContext);
    const listeners = [
        {
            type: 'message',
            action: x => {
                if (x && x.to && x.to === userDetails.username) { 
                    toast.info(`${x.from} says: ${x.text}`);
                }
            }
        }
    ];

    const updateHub = useHub("schedule-updates-hub", listeners);

    useEffect(() => { 
        return () => updateHub.disconnect();
      //eslint-disable-next-line
    },[])

    return (
        <UpdateHubContext.Provider
            value={{
                webSocket: updateHub
            }}
        >
            {children}
        </UpdateHubContext.Provider>
    );
}

export { UpdateHubContext, UpdateHubProvider };